import sendToServer from './send-to-server';

const TasterReview = {
  init() {
    if ($('.taster-review').length !== 1) return;
    $('.preference .header-row').click(this.handlePreferenceClick);
    $('.shuffle-button').click(()=>{ location.reload() });
    $('.remover').click(this.handleRemoverClick.bind(this));
    $('.shower').click(this.handleCareerShowerClick.bind(this));
    $('.favourite-button').click(this.handleFavouriteButtonClick.bind(this));
  },

  handlePreferenceClick(event) {
    let $target = $(event.target).closest('.header-row');
    if ($target.find('.glyphicon-plus').length > 0) {
      $target.find('.glyphicon')
        .removeClass('glyphicon-plus')
        .addClass('glyphicon-minus');
    } else {
      $target.find('.glyphicon')
        .removeClass('glyphicon-minus')
        .addClass('glyphicon-plus');
    }
    $target.closest('.preference').find('.options').slideToggle(100);
  },

  handleRemoverClick(event) {
    const $target = $(event.target).closest('.remover');
    let path = '';
    if ($target.data('topic-id')) {
      path = '/api/v2/topic_preferences/' + $target.data('topic-id');
    } else {
      path = '/api/v2/career_preferences/' + $target.data('career-id');
    }

    sendToServer(path,
                 null,
                 null,
                 "DELETE");

    $target.closest('.fadeable').fadeOut();
  },

  handleCareerShowerClick(event) {
    const shower = $(event.target).closest('.shower');
    const showable = shower.closest('.career-button').find('.showable');
    if (showable.is(':visible')) {
      $('.showable').slideUp();
      shower.find('.toggle-icon')
            .removeClass('glyphicon-minus')
            .addClass('glyphicon-plus');
    } else {
      $('.showable').slideUp();
      $('.toggle-icon.glyphicon-minus').removeClass('glyphicon-minus')
                                       .addClass('glyphicon-plus');
      showable.slideDown();
      shower.find('.toggle-icon')
            .removeClass('glyphicon-plus')
            .addClass('glyphicon-minus');
    }
  },

  handleFavouriteButtonClick(event) {
    const button = $(event.target).closest('.favourite-button');
    button.fadeOut();
    sendToServer('/api/v2/career_relationships/' + button.data('career-id'),
                 { favourite: true },
                 null,
                 "PATCH");
  }
}

$(document).ready(()=> {
  TasterReview.init();
});
